import { render, staticRenderFns } from "./BoardCardObservationContent.vue?vue&type=template&id=368801dc&"
import script from "./BoardCardObservationContent.vue?vue&type=script&lang=js&"
export * from "./BoardCardObservationContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports